// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["./style-fme-ccfw-shipping-block-frontend"], () => (__webpack_require__("./src/js/fme-ccfw-shipping-block/frontend.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
